<template>
  <main-layout>
    <manage-clients-container />
    <import-clients-container />
  </main-layout>
</template>

<script>

import ManageClientsContainer from '@/components/Widgets/ManageClientsContainer';
import ImportClientsContainer from '@/components/Widgets/ImportClientsContainer';

export default {
  name: 'ManageClients',
  components: {
    ManageClientsContainer,
    ImportClientsContainer,
  },
};
</script>

<style lang="scss" scoped>

</style>
